import {reqWithToken} from './requestHelper';

export async function getEmployeesWithKey(key){
    return (await reqWithToken('api/employees',{
        params:{
            key
        }
    })).data;
}